<template>
<h1>Index</h1>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/Index.vue